export const FONT_FAMILY_OPTIONS = [
  { label: "Inter", value: "Inter, system-ui, sans-serif" },
  { label: "Arial", value: "Arial, sans-serif" },
  { label: "Georgia", value: "Georgia, serif" },
  { label: "Monospace", value: "'Courier New', monospace" },
];

export const FONT_SIZE_OPTIONS = [
  { label: "12", value: "12px" },
  { label: "14", value: "14px" },
  { label: "16", value: "16px" },
  { label: "18", value: "18px" },
  { label: "24", value: "24px" },
  { label: "32", value: "32px" },
];

export const HEADING_LEVELS = [1, 2, 3, 4, 5, 6];

export const DEFAULT_TOOLBAR_OPTIONS = {
  history: true,
  textStyle: true,
  headings: true,
  alignment: true,
  lists: true,
  insert: true,
  blocks: true,
  extras: true,
};
